(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[-_/]+/g, ' ')
      .replace(/[^a-z0-9+& ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function searchText(value) {
    var text = normalize(value)
      .replace(/\b(?:finance|financial)\s+(?:course|courses|bundle|bundles)\b/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (/\blbo\b|leveraged buyout|buyout/.test(text)) text += ' leveraged buyout lbo buyout modeling';
    if (/equity research|research analyst|stock research|equity analyst/.test(text)) text += ' equity research research analyst stock research equity analyst';
    if (/fp&a|fpna|financial planning and analysis/.test(text)) text += ' fp&a fpna financial planning and analysis';
    return text;
  }

  function queryMatches(haystack, query) {
    var cleanQuery = searchText(query);
    if (!cleanQuery) return true;
    if (haystack.indexOf(cleanQuery) !== -1) return true;
    return cleanQuery.split(' ').filter(function (term) { return term.length > 1; }).every(function (term) {
      return haystack.indexOf(term) !== -1;
    });
  }

  function categoriesFor(card) {
    return String(card.getAttribute('data-categories') || '')
      .split('||')
      .map(normalize)
      .filter(Boolean);
  }

  function learnerNumber(card) {
    var raw = String(card.getAttribute('data-learners') || '').replace(/[^0-9]/g, '');
    return raw ? parseInt(raw, 10) : 0;
  }

  function init(root) {
    if (!root || root.getAttribute('data-wsm-std-ready') === 'true') return;
    root.setAttribute('data-wsm-std-ready', 'true');

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wsm-std-card]'));
    var list = root.querySelector('[data-wsm-std-list]');
    var count = root.querySelector('[data-wsm-std-count]');
    var search = root.querySelector('[data-wsm-std-search]');
    var sort = root.querySelector('[data-wsm-std-sort]');
    var empty = root.querySelector('[data-wsm-std-empty]');
    var clear = root.querySelector('[data-wsm-std-clear]');
    var filters = root.querySelector('[data-wsm-std-filters]');
    var filterToggle = root.querySelector('[data-wsm-std-filter-toggle]');
    var filterInputs = Array.prototype.slice.call(root.querySelectorAll('[data-wsm-std-filter]'));
    var topicButtons = Array.prototype.slice.call(root.querySelectorAll('[data-wsm-std-topic]'));
    var menuToggle = root.querySelector('[data-wsm-std-menu-toggle]');
    var mobileMenu = root.querySelector('[data-wsm-std-mobile-menu]');

    cards.forEach(function (card, index) {
      card.setAttribute('data-wsm-std-original-index', String(index));
    });

    function selected(type) {
      return filterInputs.filter(function (input) {
        return input.getAttribute('data-wsm-std-filter') === type && input.checked;
      }).map(function (input) { return normalize(input.value); });
    }

    function familyPriority(card) {
      var family = normalize(card.getAttribute('data-family'));
      if (family === 'elite') return 0;
      if (family === 'bundle') return 1;
      if (family === 'course') return 2;
      if (family === 'vault') return 3;
      return 4;
    }

    function originalIndex(card) {
      return parseInt(card.getAttribute('data-wsm-std-original-index'), 10) || 0;
    }

    function sortOrder(card) {
      var value = parseInt(card.getAttribute('data-sort-order'), 10);
      return Number.isFinite(value) ? value : 999999;
    }

    function sortCards() {
      if (!list) return;
      var mode = sort ? sort.value : 'relevance';
      var sorted = cards.slice().sort(function (a, b) {
        if (mode === 'price-asc') return (parseFloat(a.getAttribute('data-price')) || 0) - (parseFloat(b.getAttribute('data-price')) || 0);
        if (mode === 'price-desc') return (parseFloat(b.getAttribute('data-price')) || 0) - (parseFloat(a.getAttribute('data-price')) || 0);
        if (mode === 'rating') return (parseFloat(b.getAttribute('data-rating')) || 0) - (parseFloat(a.getAttribute('data-rating')) || 0);
        if (mode === 'popular') {
          var familyDifference = familyPriority(a) - familyPriority(b);
          if (familyDifference && (familyPriority(a) === 0 || familyPriority(b) === 0)) return familyDifference;
          var learnerDifference = learnerNumber(b) - learnerNumber(a);
          if (learnerDifference) return learnerDifference;
          return (parseFloat(b.getAttribute('data-rating')) || 0) - (parseFloat(a.getAttribute('data-rating')) || 0);
        }
        var orderDifference = sortOrder(a) - sortOrder(b);
        if (orderDifference) return orderDifference;
        var familyDifference = familyPriority(a) - familyPriority(b);
        if (familyDifference) return familyDifference;
        return originalIndex(a) - originalIndex(b);
      });
      sorted.forEach(function (card) { list.appendChild(card); });
    }

    function updateCounts() {
      ['course', 'bundle', 'elite', 'vault'].forEach(function (family) {
        var total = cards.filter(function (card) { return normalize(card.getAttribute('data-family')) === family; }).length;
        root.querySelectorAll('[data-wsm-std-family-count="' + family + '"]').forEach(function (node) { node.textContent = total; });
      });
      ['Financial Modeling', 'Investment Banking', 'AI', 'Excel', 'FP&A', 'Accounting', 'Capital Markets', 'Valuation'].forEach(function (topic) {
        var cleanTopic = normalize(topic);
        var total = cards.filter(function (card) { return categoriesFor(card).indexOf(cleanTopic) !== -1; }).length;
        root.querySelectorAll('[data-wsm-std-topic-count="' + topic + '"]').forEach(function (node) { node.textContent = total; });
      });
    }

    function updateFilterToggle() {
      if (!filterToggle) return;
      var active = filterInputs.filter(function (input) { return input.checked; }).length + (search && search.value.trim() ? 1 : 0);
      filterToggle.textContent = active ? 'Filters active (' + active + ')' : 'Filter programs';
      filterToggle.setAttribute('aria-expanded', filters && filters.classList.contains('is-open') ? 'true' : 'false');
    }

    function render() {
      var families = selected('family');
      var topics = selected('topic');
      var query = search ? search.value : '';
      var visible = 0;

      cards.forEach(function (card) {
        var family = normalize(card.getAttribute('data-family'));
        var cardCategories = categoriesFor(card);
        var haystack = searchText(
          String(card.getAttribute('data-search') || '') + ' ' +
          String(card.getAttribute('data-title') || '') + ' ' +
          String(card.getAttribute('data-categories') || '')
        );
        var familyMatches = !families.length || families.indexOf(family) !== -1;
        var topicMatches = !topics.length || topics.some(function (topic) { return cardCategories.indexOf(topic) !== -1; });
        var matches = familyMatches && topicMatches && queryMatches(haystack, query);
        card.classList.toggle('is-hidden', !matches);
        if (matches) visible += 1;
      });

      sortCards();
      if (count) count.innerHTML = 'Showing <strong>' + visible + '</strong> relevant result' + (visible === 1 ? '' : 's');
      if (empty) empty.hidden = visible > 0;
      updateFilterToggle();
    }

    function setTopic(value) {
      var cleanValue = normalize(value);
      filterInputs.filter(function (input) {
        return input.getAttribute('data-wsm-std-filter') === 'topic';
      }).forEach(function (input) {
        input.checked = cleanValue !== 'all' && normalize(input.value) === cleanValue;
      });
      topicButtons.forEach(function (button) {
        button.classList.toggle('is-active', normalize(button.getAttribute('data-wsm-std-topic')) === cleanValue);
      });
      render();
    }

    filterInputs.forEach(function (input) { input.addEventListener('change', render); });
    if (search) search.addEventListener('input', render);
    if (sort) sort.addEventListener('change', render);
    if (clear) clear.addEventListener('click', function () {
      filterInputs.forEach(function (input) { input.checked = false; });
      if (search) search.value = '';
      topicButtons.forEach(function (button) { button.classList.toggle('is-active', button.getAttribute('data-wsm-std-topic') === 'all'); });
      render();
    });
    topicButtons.forEach(function (button) {
      button.addEventListener('click', function () { setTopic(button.getAttribute('data-wsm-std-topic') || 'all'); });
    });
    if (filterToggle) filterToggle.addEventListener('click', function () {
      if (filters) filters.classList.toggle('is-open');
      updateFilterToggle();
    });
    if (menuToggle && mobileMenu) menuToggle.addEventListener('click', function () {
      var open = mobileMenu.hasAttribute('hidden');
      if (open) mobileMenu.removeAttribute('hidden'); else mobileMenu.setAttribute('hidden', 'hidden');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    updateCounts();
    render();
  }

  function start() {
    document.documentElement.classList.add('wsm-catalog-standardized-page');
    document.querySelectorAll('[data-wsm-std-catalog]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
